export default interface UserState {
    username: string
    displayName: string,
    roles: string[]
}

export const getDefaultUserState = (): UserState => {
    return {
        username: '',
        displayName: '',
        roles: [] as string[]
    }
}
